import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Person } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
export function NoContactSelected() {
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'text.secondary',
            p: 4,
        }, children: [_jsx(Person, { sx: { fontSize: 80, mb: 2, opacity: 0.5 } }), _jsx(Typography, { variant: "h6", color: "text.secondary", children: "Select a contact" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 1 }, children: "Choose a contact from the list to view their details" })] }));
}
//# sourceMappingURL=NoContactSelected.js.map